<template>

  <div class="Rebate">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
      <b-row>
        <b-col cols="12 headerF"><HeaderFixed/></b-col>
        <b-col cols="12 headerM"><HeaderMobile/></b-col>
      </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

          <b-row>
            <b-col cols="12">
                <b-breadcrumb style=" background-color: #e9ecef78;">
                    <b-breadcrumb-item href="#home">
                      <router-link to="/">
                          <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                          Home
                      </router-link>
                    </b-breadcrumb-item>
                    <b-breadcrumb-item href="#ApplyNewConn" active>
                      <router-link to="/ApplyNewConn">
                          Apply New Connection
                      </router-link>
                    </b-breadcrumb-item>
                    <b-breadcrumb-item href="#" active>Estimate Service Cost</b-breadcrumb-item>
                </b-breadcrumb>
              </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <span class="title"> Estimate Service Cost</span>
            </b-col>
          </b-row>
          <hr/>
          <div class="paddingLeft30px">
            <br>
            <b-row>
                  <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 15px;">
                        <span style="font-weight:600" >Select Category <span class="text-danger">*</span></span>
                  </b-col>
                  <b-col col cols="12" sm="12" md="8" lg="3" style="padding-top: 10px;">
                    <select name="" id="selectCategory" required style="height:2rem;width:100%" @change="changeSelect()">
                        <option selected  value="0">---Select---</option>
                    </select>
                    </b-col>
                    <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 15px;">
                          <span style="font-weight:600" id="loadSpan">Enter Load <span class="text-danger">*</span></span>
                    </b-col>
                  <b-col col cols="12" sm="12" md="8" lg="3" style="padding-top: 10px;">
                      <b-form-input type="number" maxlength="12" id="load"  trim required />

                      <span id="loadRange"></span>
                  </b-col>
              </b-row>
              <div id="landOwnerDiv">
                <b-row id ="" >
                  <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 15px;">
                        <span style="font-weight:600" >Is Applicant Owner of the Land? <span class="text-danger">*</span></span>
                  </b-col>
                  <b-col col cols="12" sm="12" md="8" lg="3" style="padding-top: 10px;">
                    <select name="" id="landOwner" required style="height:2rem;width:100%" >
                        <option selected  value="0">---Select---</option>
                        <option value="Y">Yes</option>
                        <option value="N">No</option>
                    </select>
                  </b-col>
                </b-row>
              </div>
             
              <div id="noOfDaysDiv"  class="hideDetails">
                <b-row id ="" >
                      <b-col col cols="12" sm="12" md="2" lg="2" style="padding-top: 15px;padding-left: 15px;">
                          <span style="font-weight:600" >No. of Days <span class="text-danger">*</span></span>
                      </b-col>
                      <b-col col cols="12" sm="12" md="3" lg="3" style="padding-top: 15px;">
                        <b-form-input type="number" id="noOfDays" value="0"  placeholder="" trim required />
                    </b-col>
                </b-row>
              </div>
              <br>
              <div id="calculateButton">
                  <b-row>
                    <b-col col sm="12" md="3" lg="2" >
                            <b-button variant="primary" @click="showDetails()" style="width:100%;">
                              <b-icon icon="file-earmark-check" animation=" "></b-icon> Calculate
                            </b-button>
                    </b-col>
                  </b-row>
              </div>
              <br>
              <div id="EstimateDetailsDiv" class="hideDetails" style="width:90vw;font-size:0.8rem">
                  <span class="heading"> Cost Details</span>
                  
                <br><br>
                <b-row>
                    <b-col col sm="12" md="8" lg="8" style="padding-top: 7px;">
                      <b-table  bordered responsive :items="cost" :fields="costFields" style="">
                      </b-table>
                    </b-col>
                </b-row>
                <div id="showMsg" class="hideDetails" style="padding-top:0px;">
                 <!-- <span style="color:red; text-transform: capitalize;">Note:</span>  As per AERC guidelines, required Service Connection 
                  price changes in Final bill of New Service Connection is under implementation and the same will be made live shortly-->
                </div>
                <span style="color:red; text-transform: capitalize;">
                <!-- ( * The calculated cost shown here is an approximate value, the actual value may differ. )--></span>
                <br> <br> 
                <span id="note1"><!--N.B :  If service line required is excess of 30 meters, service line charges is to be paid as per actual estimate, prepared by
                SDE office--></span> 
              </div>
              

        <!-- for ht consumers -->
        
        <br>
        </div>
      </b-container>

      <br><br>
    </b-overlay>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="msg">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
    </b-modal>
  </div>
</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var consNo="";
var sdCode="";
var thColor = '#0288d1';
var categoryList = [];
var catCode = "";
export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      costFields: [
        { key: 'item', label: 'Item',thStyle: {width: '80vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'cost', label: 'Cost',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'costSmart', label: 'Cost (Smart)',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }

      ],
      cost : [

      ],
      show:false
    }
  },
  methods: {
    showDetails() {
      var cat = document.getElementById("selectCategory").value;
      var landOwner = document.getElementById("landOwner").value;
      var load = document.getElementById("load").value;
      console.log("landOwner::"+landOwner);
      console.log("cat::::::"+cat);
      if(cat == '0')
      {
        this.$bvToast.toast('Select a Category', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return
      }

      if(catCode >55 && catCode !=69 && catCode!=75 && catCode!=72){
        if((load<parseFloat("31")) || (load>parseFloat("150")) )
        {
          this.$bvToast.toast('Enter  load  within range', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return
        }
      }
      
      var noOfDays = document.getElementById("noOfDays").value;
      
      console.log("Days:"+noOfDays)
      if(noOfDays == "")
      {
        this.$bvToast.toast('Enter No Of Days ', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return
      }

      var sel = document.getElementById("selectCategory");
     
      var selectText= sel.options[sel.selectedIndex].text;
      var link = categoryList.filter(function(obj) { return obj.category_CODE == selectText; });

      var lowerLoad = parseFloat(link[0].lower_LOAD_KW);
      var higherLoad = parseFloat(link[0].higher_LOAD_KW);
      console.log(lowerLoad+"::::::"+higherLoad)

      
      var serviceConnectionCharge ="";

      //newly added for the HT consumer
      if(catCode >55 && catCode !=69 && catCode!=75 && catCode!=72){
        if(landOwner == "0" && catCode!=70){
          this.$bvToast.toast('Select if Land Owner or Not !! ', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return
        }
        else if(load==""){
          console.log("load::::::"+load);
          this.$bvToast.toast('Enter Valid Load !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return
        }
      }
      else if(catCode==70)
      {
        
      }
      else{
        if(load == "" || parseFloat(load)<lowerLoad || parseFloat(load)>higherLoad)
        {
          this.$bvToast.toast('Enter Valid Load !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return
        }
        

        if((landOwner == "0" ) && (catCode != "54" && catCode != "55" && catCode != 69))
        {
          this.$bvToast.toast('Select if Land Owner or Not !! ', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return
        }
      }
      
      this.show=true;
      var parent=this;
      console.log("load::::"+load);
    
      axios.post(this.$urlArms+'/RestAPI/nscCalc?cat='+cat+'&load='+load+'&noDays='+noOfDays)
      .then((response) => {
        parent.show=false;
      console.log(response.data);
      var data = response.data;
      var loadSecurity = "";
      serviceConnectionCharge = response.data.serviceConnectionCharge;
      console.log("serviceConnectionCharge::::"+serviceConnectionCharge);
      if(landOwner == "N")
      {
        loadSecurity = data.otherLoad;
      }
      else {
        loadSecurity = data.normalLoad;
      }
      if(catCode >55 && catCode !=69 && catCode!=75 && catCode!=72 && catCode!=70)
      { 
        var ls=parseFloat(loadSecurity)*parseFloat(load);
        var costofconstruction=parseFloat(serviceConnectionCharge)*parseFloat(load);
        var total = parseFloat(ls)+parseFloat(data.meterCost)+parseFloat(data.installationCharge)+parseFloat(costofconstruction);
        
        
        this.cost = [
                    {"item":"Load Security","cost":"₹"+ls.toFixed(2)},
                    {"item":"Meter Cost (without GST)","cost":"₹"+data.meterCost},
                    {"item":"Installation Charge","cost":"₹"+data.installationCharge},
                    {"item":"Cost of Service Connection", "cost":"₹"+costofconstruction.toFixed(2)},
                    {"item":"Total Cost","cost": "₹"+total.toFixed(2)}
                ]
                
        document.getElementById("showMsg").classList.add("showDetails");
      }
      else if(catCode==70)
      {
      
        var costofconstruction=parseFloat(serviceConnectionCharge)*parseFloat(load);
        var total = parseFloat(data.energyCharge)+parseFloat(data.meterSecurityCost)+parseFloat(data.disconnectionCharge)+parseFloat(costofconstruction);
          this.cost = [
                      {"item":"Energy Charge","cost":"₹"+data.energyCharge},
                      {"item":"Meter Security","cost":"₹"+data.meterSecurityCost},
                      {"item":"Disconnection Charge","cost":"₹"+data.disconnectionCharge},
                      {"item":"Cost of Service Connection", "cost":"₹"+costofconstruction.toFixed(2)},
                      {"item":"Total Cost","cost": "₹"+total.toFixed(2)}
                  ]
        // document.getElementById("noOfDaysDiv").style.display="block";          
        document.getElementById("noOfDaysDiv").classList.add("showDetails");
        document.getElementById("showMsg").classList.add("showDetails");

      }
      else if(catCode == "54" || catCode == "55" || catCode == "69")
        {
          var total = parseFloat(data.energyCharge)+parseFloat(data.meterSecurityCost)+parseFloat(data.disconnectionCharge);
              this.cost = [
                        {"item":"Energy Charge","cost":"₹"+data.energyCharge},
                        {"item":"Meter Security","cost":"₹"+data.meterSecurityCost},
                        {"item":"Disconnection Charge","cost":"₹"+data.disconnectionCharge},
                        {"item":"Total Cost","cost": "₹"+total.toFixed(2)}
                    ]
              document.getElementById("noOfDaysDiv").classList.add("showDetails");
              document.getElementById("showMsg").classList.remove("showDetails");

        }
      else
        {
          var totalCost = parseFloat(loadSecurity)+parseFloat(data.meterCost)+parseFloat(data.installationCharge);
          var totalCostSmart = 0;
          var meterCostSmart = 0;
          if(parseFloat(load)<5)
          {
            meterCostSmart = data.smartSinglePhase;
            console.log("meterCostSmart :::"+meterCostSmart );
            totalCostSmart = parseFloat(loadSecurity)+parseFloat(data.smartSinglePhase)+parseFloat(data.installationCharge);
          }
          else
          {
            meterCostSmart = data.smartThreePhase;
            totalCostSmart = parseFloat(loadSecurity)+parseFloat(data.smartThreePhase)+parseFloat(data.installationCharge);
          }
          this.cost = [
                    {"item":"Load Security","cost":"₹"+loadSecurity,"costSmart":"₹"+loadSecurity+" (for postpaid)"},
                    {"item":"Meter Cost (without GST)","cost":"₹"+data.meterCost,"costSmart":"₹"+meterCostSmart},
                    {"item":"Installation Charge","cost":"₹"+data.installationCharge,"costSmart":"₹"+data.installationCharge},
                    {"item":"Total Cost","cost": "₹"+totalCost.toFixed(2),"costSmart":"₹"+totalCostSmart.toFixed(2)}
                   ]

            document.getElementById("showMsg").classList.remove("showDetails");

        }

        document.getElementById("EstimateDetailsDiv").classList.add("showDetails");

      })
    },

    changeSelect()
    {
      catCode = document.getElementById("selectCategory").value;
      var sel = document.getElementById("selectCategory");
      var selectText= sel.options[sel.selectedIndex].text;
      
      if(catCode >55 && catCode !=69 && catCode!=75 && catCode!=72 && catCode!=70){
        // console.log("category code::::::"+catCode);
        // document.getElementById("noOfDaysDiv").style.display = "none";
        document.getElementById("noOfDaysDiv").classList.remove("showDetails");
        // document.getElementById("loadRange").style.display = "none";
        // document.getElementById('loadSpan').style.display = "none";
        document.getElementById('note1').style.display = "none";
        document.getElementById("landOwnerDiv").style.display="block";
        document.getElementById("loadRange").innerHTML=" (Load Range :31KW - 150KW)";
      }
      else if(catCode == 70){
        console.log("category code::::::"+catCode);
        // document.getElementById("noOfDaysDiv").style.display="block";
        document.getElementById("noOfDaysDiv").classList.add("showDetails");
        document.getElementById("noOfDays").value="";
        document.getElementById("landOwnerDiv").style.display="none";
        document.getElementById('note1').style.display = "none";
        document.getElementById("loadRange").innerHTML=" (Load Range :31KW - 150KW)";
      }
      else{
        var link = categoryList.filter(function(obj) { return obj.category_CODE == selectText; });
        console.log("link::::"+JSON.stringify(link));
        document.getElementById("loadRange").innerHTML="(Load Range : "+link[0].lower_LOAD_KW+"KW - "+link[0].higher_LOAD_KW+"KW )"
        console.log("category code::::::"+catCode);
        document.getElementById('EstimateDetailsDiv').style.display = "block";
        document.getElementById('load').style.display= "block";
        document.getElementById("loadRange").style.display = "block";
        document.getElementById('note1').style.display = "block";
        if(catCode == "54" || catCode == "55" || catCode == 69)
        {
      //  document.getElementById("noOfDays").classList.add("showDetails");
            // document.getElementById("noOfDaysDiv").style.display="block";
            document.getElementById("noOfDaysDiv").classList.add("showDetails");
            document.getElementById("noOfDays").value="";
            document.getElementById("landOwnerDiv").style.display="none";
        }

        else {
        //  document.getElementById("noOfDays").classList.remove("showDetails");
            // document.getElementById("noOfDaysDiv").style.display="none";
            document.getElementById("noOfDaysDiv").classList.remove("showDetails");
            document.getElementById("noOfDays").value="0";
            document.getElementById("landOwnerDiv").style.display="block";
        }
        // document.getElementById("loadRange").innerHTML="(Load Range : "+link[0].lower_LOAD_KW+"KW - "+link[0].higher_LOAD_KW+"KW )"
      }
      

      var link = categoryList.filter(function(obj) { return obj.category_CODE == selectText; });
      console.log(link);

        // document.getElementById("loadRange").innerHTML="(Load Range : "+link[0].lower_LOAD_KW+"KW - "+link[0].higher_LOAD_KW+"KW )"
    },

    closeModal(){
      this.$bvModal.hide('model')
    },

  calculateInstallment(n){
  return n;

  }
},
  mounted()
  {
    this.show=true;
    var parent=this;
    axios.post('https://www.apdclrms.com/cbs/RestAPI/crm/getAllCategoryList')
    .then((response) => {
      this.show=false;
      categoryList = response.data;
    // console.log(response.data);
    //document.getElementById("selectDistrict").empty();
     var select = document.getElementById("selectCategory");

     response.data.forEach(function (element, index){
      var optionValue=element.category_CODE.split("-");
        //  console.log(optionValue[0]);
      var  option = document.createElement("option");
        option.text = element.category_CODE;
        option.value = optionValue[0];
        //console.log("option.value[0]::"+option.value)
        if (option.value == "77" || option.value == "76" ){
                    option.style.display = "none";
        }
        select.appendChild(option);
      })

    })
  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">


.paddingRow{
  padding:0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.hideDetails
{
   visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
/*  box-shadow: 2px 2px 10px 2px #bdbdbd; */
  padding-top: 1rem;
  /* margin-right: 1.5rem; */
}
.showDetails
{
  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
@media only screen and (max-width: 414px) {
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
}


</style>
